import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (
  listingId: number,
  hash: string,
  lang?: string,
) =>
  makeCall<undefined>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/calendar/${hash}`,
    {
      query: { lang },
    },
  );
